import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=38b7a436&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"
import style0 from "./Client.vue?vue&type=style&index=0&id=38b7a436&prod&scoped=scoped&lang=css"
import style1 from "./Client.vue?vue&type=style&index=1&id=38b7a436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7a436",
  null
  
)

export default component.exports